import React from "react";
import {useLocation} from "react-router-dom";
import {useLocaleContext} from "../../../../context/LocaleContext";
import {STREAM_STATUSES} from "../../../../constants/common";
import { getStreamMeta } from "../../../../../../common/src/stream";
import SubtitleWaiting from "./SubtitleWaiting";

const DefaultSubtitle = ({settings, children}) => (
    <div style={{
        fontSize: (!!settings && settings?.subtitleSize) ? settings?.subtitleSize : '',
        fontWeight: (!!settings && settings?.subtitleBold) ? 'bold' : 'normal',
        minHeight: '1.4em'
    }}>
        {children} 
    </div>
);

const SubtitleSwitch = ({status, diffStartTimeout, stream, pageName = "broadcast"}) => {
    const {get} = useLocaleContext();

    switch (status) {
        case STREAM_STATUSES.WAITING:
            return (
                <SubtitleWaiting
                    isShowStopEvent={pageName === "halls"}
                    diffStartTimeout={Number(diffStartTimeout)}
                    pageName={pageName}
                    stream={stream}
                />
            );
        case STREAM_STATUSES.STOPPED:
            return <p>{get(`${pageName}.overlay.stopped.title`)}</p>;
        default:
            return null;
    }
}

const Subtitle = ({settings, stream}) => {
    const {pathname} = useLocation();
    const [, , , pageName] = pathname.split('/');

    const getStatus = () => {
        if (stream) {
            const { isWaiting, isLive } = getStreamMeta(stream);
            if (isWaiting) {
                return STREAM_STATUSES.WAITING;
            } else if (isLive) {
                return STREAM_STATUSES.STARTING;
            } else {
                return STREAM_STATUSES.STOPPED;
            }
        } else {
            return STREAM_STATUSES.STOPPED;
        }
    };

    const status = getStatus();

    return (
        <DefaultSubtitle settings={settings}>
            <SubtitleSwitch
                status={status}
                diffStartTimeout={settings?.diffStartTimeout}
                pageName={pageName}
                stream={stream}
            />
        </DefaultSubtitle>
    );
}

export default Subtitle;
